import { AuthFormLocation, AuthStatusCode, ErrorMessage } from '@as-react/common-types';
const getLoginErrorMessagesByLocation = (location) => {
    switch (location) {
        case AuthFormLocation.CHECKOUT:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.CHECKOUT_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA,
            };
        case AuthFormLocation.LOGIN:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.LOGIN_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA,
            };
        case AuthFormLocation.RETURN_PORTAL:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.RETURN_PORTAL_LOGIN_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.RETURN_PORTAL_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.RETURN_PORTAL_LOGIN_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.RETURN_PORTAL_LOGIN_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.RETURN_PORTAL_LOGIN_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD,
            };
        case AuthFormLocation.LOGIN_FLOWS:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.CHECKOUT_LOGIN_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.CHECKOUT_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_OTHER_FASCIA,
            };
        case AuthFormLocation.CHECKOUT_V2:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.CHECKOUT_V2_LOGIN_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.CHECKOUT_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.LOGIN_FLOWS_USER_KNOWN_OTHER_FASCIA,
            };
        case AuthFormLocation.POPOVER:
        default:
            return {
                [AuthStatusCode.INVALID_PASSWORD]: ErrorMessage.FLYOUT_USER_KNOWN_WRONG_CREDENTIALS,
                [AuthStatusCode.UNKNOWN_ACCOUNT]: ErrorMessage.FLYOUT_USER_UNKNOWN,
                [AuthStatusCode.INVALID_ACCOUNT]: ErrorMessage.FLYOUT_USER_KNOWN_SAME_FASCIA_NO_PASSWORD,
                [AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.FLYOUT_USER_KNOWN_OTHER_FASCIA,
                [AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA]: ErrorMessage.FLYOUT_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD,
            };
    }
};
export const getLoginErrorMessage = (errorCode, location) => {
    if (!errorCode) {
        return ErrorMessage.GENERAL_ACCOUNT;
    }
    return getLoginErrorMessagesByLocation(location)[errorCode];
};
